/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_COMMENT_URL, COMMON_HEADER_CONFIG} from "../config";

class CommentService {
  getAccessToken = () => localStorage.getItem("accessToken");

  searchComments = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_COMMENT_URL}/comments`,
        params: {
          size: 1000,
          page: 1,
          type: "sku",
          ...data
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getListComment = () =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_COMMENT_URL}/comments`,
        params: {
          size: 100,
          page: 1
        },
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneComment = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_COMMENT_URL}/comment/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  createComment = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_COMMENT_URL}/comment`,
        data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  updateComment = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "PATCH",
        url: `${API_COMMENT_URL}/comment/${data.id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  deleteComment = (id) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "DELETE",
        url: `${API_COMMENT_URL}/comment/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`,
          "Content-Type": "application/json"
        },
        data: id
      };

      axios(config)
        .then((response) => {
          if (
            response.data &&
            (response.data.code === 1 || response.data.code === "success")
          ) {
            resolve(id);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  searchCommentHierarchy = (data = {}) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_COMMENT_URL}/hierarchy`,
        params: data,
        headers: {
          ...COMMON_HEADER_CONFIG,
          Authorization: `Bearer ${this.getAccessToken()}`
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const commentService = new CommentService();

export default commentService;
